import { Group, Modal, Stack, Title } from "@mantine/core"

import { Button } from "../../atoms/Button/Button"

type Props = {
  opened: boolean
  onClose: () => void
  onCancel: () => void
  title: string
  yes: string
  no: string
}

export const CancelModal = ({
  opened,
  onClose,
  onCancel,
  title,
  yes,
  no,
}: Props) => {
  return (
    <Modal opened={opened} onClose={onClose} size="lg">
      <Stack>
        <Modal.Header>
          <Title order={3}>{title}</Title>
        </Modal.Header>
        <Modal.Body>
          <Group grow w="100%">
            <Button
              fullWidth
              onClick={() => {
                onCancel()
                onClose()
              }}
            >
              {yes}
            </Button>
            <Button fullWidth variant="secondary" onClick={onClose}>
              {no}
            </Button>
          </Group>
        </Modal.Body>
      </Stack>
    </Modal>
  )
}
